<template>
  <section id="servicios-presenciales" class="servicios-presenciales">
    <div class="container overflow-visible">
      <div class="content-wrapper">
        <div class="image-column">
          <div class="image-container">
            <img 
              src="@/assets/images/serviciospresenciales.jpg" 
              alt="Estudiantes en la biblioteca" 
              class="section-image"
            />
          </div>
        </div>
        <div class="text-column">
          <p class="section-label">Servicios presenciales</p>
          <h2 class="section-title">Libros, notebooks y salas de estudios</h2>
          <p class="section-description">
            Accede a espacios, recursos y tecnología para estudiar de forma individual o en grupo. En las bibliotecas AIEP puedes pedir libros, reservar salas y usar notebooks, con atención presencial en todas las sedes. Consulta en el mesón de atención de cada biblioteca con tu cédula de identidad.
          </p>
          
          <div class="what-can-i-request">
            <h3>¿Qué puedo solicitar?</h3>
            <ul class="services-list">
              <li>
                <div class="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.5582 15.174C17.5068 15.5015 17.2177 15.7392 16.8901 15.7135C16.6396 15.7007 16.2864 15.6428 15.8817 15.5722C15.1752 15.4502 14.2952 15.3024 13.3959 15.3024C12.3425 15.3024 11.5268 15.5465 10.8716 15.7456C10.7881 15.7713 10.7111 15.7906 10.634 15.8163V6.29714C11.2056 5.93102 12.6766 5.09601 14.2245 5.08959C14.2374 5.08959 15.4192 4.98682 16.5818 5.53278C17.1214 5.78329 17.6995 6.32283 17.6995 6.90734V11.4678C17.7123 12.6689 17.7187 14.1655 17.5582 15.1804V15.174ZM9.11169 15.7456C8.45653 15.5465 7.64079 15.3024 6.58739 15.3024C5.68815 15.3024 4.80817 15.4502 4.10162 15.5722C3.69697 15.6428 3.34369 15.7007 3.09319 15.7135C2.77203 15.7328 2.47656 15.5015 2.42518 15.174C2.2646 14.1591 2.27102 12.6625 2.27745 11.4614V6.90092C2.27745 6.31641 2.85553 5.77686 3.39508 5.52636C4.55767 4.98682 5.73953 5.08316 5.81661 5.08959C7.31963 5.08959 8.77769 5.9246 9.34935 6.29072V15.8098C9.27227 15.7842 9.1952 15.7649 9.11169 15.7392V15.7456ZM18.9905 11.4549V6.90734C18.9905 5.67409 17.9885 4.76843 17.1342 4.37019C15.6441 3.67649 14.1731 3.80495 14.1731 3.81138C12.3811 3.81138 10.7239 4.71704 9.99809 5.17951C9.2787 4.71704 7.63437 3.81138 5.89369 3.81138C5.83588 3.80495 4.35855 3.67007 2.86838 4.37019C2.0141 4.76843 1.00566 5.67409 1.00566 6.90734V11.4614C0.992812 12.7075 0.986389 14.2619 1.16624 15.3795C1.32039 16.3622 2.17467 17.0559 3.17669 16.9981C3.49785 16.9789 3.88324 16.9146 4.32644 16.8376C5.02014 16.7219 5.81019 16.5871 6.60024 16.5871C7.46736 16.5871 8.14822 16.7926 8.752 16.9724C8.88688 17.011 9.01535 17.0495 9.14381 17.0881C9.42643 17.1651 9.71547 17.2037 9.99809 17.2037C10.2807 17.2037 10.5762 17.1651 10.8588 17.0881C10.9873 17.0559 11.1157 17.011 11.2506 16.9724C11.8544 16.7926 12.5417 16.5871 13.4024 16.5871C14.1924 16.5871 14.9825 16.7219 15.6762 16.8376C16.1194 16.9146 16.5048 16.9789 16.8259 16.9981C17.8408 17.0559 18.6822 16.3558 18.8364 15.3795C19.0162 14.2554 19.0034 12.701 18.9969 11.4549H18.9841H18.9905Z" fill="white"/>
                  </svg>
                </div>
                <span>Libros impresos para préstamo a domicilio o consulta en sala.</span>
              </li>
              <li>
                <div class="icon-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="9" stroke="white" stroke-width="2"/>
                    <path d="M12 7V12L15 15" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <span>Reserva una sala de estudio por 1 hora.</span>
              </li>
              <li>
                <div class="icon-circle">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M17.0721 15.7H2.93431C2.58086 15.7 2.29168 15.4075 2.29168 15.05C2.29168 14.6925 2.58086 14.4 2.93431 14.4H17.0657C17.4191 14.4 17.7083 14.6925 17.7083 15.05C17.7083 15.4075 17.4191 15.7 17.0657 15.7H17.0721ZM3.76973 6.40501C3.8854 5.76801 4.47019 5.3 5.1578 5.3H14.8486C15.5362 5.3 16.121 5.76151 16.2367 6.40501C16.4038 7.32801 16.4295 8.2965 16.4295 9.2C16.4295 10.1035 16.4038 11.0785 16.2367 11.995C16.1275 12.5735 15.472 13.1 14.8486 13.1H5.1578C4.53445 13.1 3.87897 12.5735 3.76973 11.995C3.60264 11.072 3.57694 10.1035 3.57694 9.2C3.57694 8.2965 3.60264 7.32151 3.76973 6.40501ZM17.1492 13.1065C17.3227 12.84 17.4448 12.541 17.5027 12.2355C17.6826 11.267 17.7147 10.2595 17.7147 9.2C17.7147 8.1405 17.6762 7.1395 17.5027 6.1645C17.2713 4.9165 16.1596 4 14.8486 4H5.1578C3.84684 4 2.73509 4.9165 2.50375 6.1645C2.32381 7.133 2.29168 8.1405 2.29168 9.2C2.29168 10.2595 2.33024 11.2605 2.50375 12.2355C2.56159 12.5475 2.68368 12.84 2.85719 13.1065C1.82899 13.1455 1 13.997 1 15.05C1 16.103 1.86755 17 2.92788 17H17.0721C18.1325 17 19 16.1225 19 15.05C19 13.9775 18.1774 13.152 17.1492 13.1065Z" fill="white"/>
                  </svg>
                </div>
                <span>Pide un notebook para trabajar.</span>
              </li>
              <li>
                <div class="icon-circle">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="18" cy="5" r="3" stroke="white" stroke-width="2"/>
                    <circle cx="6" cy="12" r="3" stroke="white" stroke-width="2"/>
                    <circle cx="18" cy="19" r="3" stroke="white" stroke-width="2"/>
                    <path d="M8.59 13.51L15.42 17.49" stroke="white" stroke-width="2"/>
                    <path d="M15.41 6.51L8.59 10.49" stroke="white" stroke-width="2"/>
                  </svg>
                </div>
                <span>Si estudias Online, utiliza estos servicios en cualquier sede.</span>
              </li>
            </ul>
          </div>
          
          <button class="btn-primary-red" @click="scrollToBibliotecas">Ver horarios y ubicaciones</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ServiciosPresencialesSection',
  methods: {
    scrollToBibliotecas() {
      const section = document.getElementById('bibliotecas')
      if (section) {
        const headerHeight = 80
        const top = section.getBoundingClientRect().top + window.pageYOffset - headerHeight
        window.scrollTo({ top, behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.servicios-presenciales {
  background-color: #182844;
  padding: 80px 0;
  color: #FFFFFF;
  position: relative;
  overflow: visible;
}

.content-wrapper {
  display: flex;
  align-items: stretch;
  gap: 60px;
}

.image-column {
  flex: 1;
  order: 2;
  display: flex;
}

.text-column {
  flex: 1;
  order: 1;
  display: flex;
  flex-direction: column;
}

.image-container {
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.3);
  flex: 1;
}

.section-image {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.section-label {
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 12px;
  color: #FFFFFF;
}

.section-title {
  font-family: 'Ubuntu', sans-serif;
  font-size: 40px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 24px;
  color: #FFFFFF;
}

.section-description {
  font-family: 'Verdana', sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.6;
  color: #FFFFFF;
  margin-bottom: 32px;
}

.what-can-i-request h3 {
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: 20px;
}

.services-list {
  list-style: none;
  padding: 0;
  margin: 0 0 40px 0;
}

.services-list li {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 18px;
  font-family: 'Verdana', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.6;
  color: #FFFFFF;
}

.icon-circle {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.icon-circle svg {
  width: 20px;
  height: 20px;
}

.btn-primary-red {
  background-color: #AA0000;
  color: #FFFFFF;
  border: none;
  width: 250px;
  height: 47px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  font-family: 'Ubuntu', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

@media (max-width: 768px) {
  .btn-primary-red {
    width: 341px;
    max-width: 100%;
    height: 44px;
    font-size: 14px;
    padding: 0;
    margin: 0 auto;
  }
}

.btn-primary-red:hover {
  background-color: #990000;
}

@media (max-width: 991px) {
  .content-wrapper {
    flex-direction: column;
    gap: 40px;
  }
  
  .image-column {
    order: 1;
    width: 100%;
  }
  
  .text-column {
    order: 2;
    width: 100%;
  }
  
  .section-title {
    font-size: 32px;
  }
}

@media (max-width: 768px) {
  .servicios-presenciales {
    padding: 60px 0;
  }
  
  .section-title {
    font-size: 26px;
  }
  
  .section-description {
    font-size: 14px;
  }
}

/* Ensure container is centered and has proper width */
.container {
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
</style>
